(() => {
  const availability = 'filter.v.availability';
  const decorate = link => {
    if (!link || !link.hasAttribute('href') || link.hasAttribute('data-filter-input')) return;
    const url = new URL(link.getAttribute('href'), window.location.href);
    if (url.origin !== window.location.origin) return;
    const collection = /\/collections\/[^/]+(?:\/[^/]+)?\/?$/.test(url.pathname)
      && !url.pathname.includes('/products/');
    const search = /\/search\/?$/.test(url.pathname);
    if ((collection || search) && !url.searchParams.has(availability)) {
      url.searchParams.set(availability, '1');
      link.setAttribute('href', url.pathname + url.search + url.hash);
    }
  };
  document.querySelectorAll('a[href]').forEach(decorate);
  document.addEventListener('click', event => {
    if (event.target instanceof Element) decorate(event.target.closest('a[href]'));
  }, true);
})();
